import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Select from "react-select";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { Accordion, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../../../components/Pagination";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";

const EmployeeITDeclarations = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [tableAccordianData, setTableAccordianData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(150);
  const [currentPage, setCurrentPage] = useState(1);
  const [financialYearOptions, setFinancialYearsOptions] = useState([]);
  const [regimeTypeOptions, setRegimeTypeOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);

  // Update Navbar Heading
  useEffect(() => {
    dispatch(updateNavbarHeading("Employee IT Declaration"));
  }, [dispatch]);

  // Fetch Data from API
  useEffect(() => {
    fetchGetApi();
  }, []);

  const fetchGetApi = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}income/tax/declarations`
      );
      if (response?.status === 200) {
        const cleanedData = response?.data;
        // console.log("response", response?.data?.financialyear);

        const finanYrsOpt = response?.data?.financialyear
          ?.map((ele) => ({
            value: ele?.value,
            label: ele?.text,
            FYToDate: ele?.FYToDate,
            FYFromDate: ele?.FYFromDate,
          }))
          .reverse();

        setFinancialYearsOptions(finanYrsOpt);


        const regimOpt = response?.data?.regimeType?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setRegimeTypeOptions(regimOpt);
        const empOpt = response?.data?.employeeListing?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setEmployeeOptions(empOpt);
      }
    } catch (error) {
      console.error("Unexpected Error Occurred", error);
    }
  };

  const [taxRegimeFetchValue, setTaxRegimeFetchValue] = useState(null);
  const [cumulativeDetails, setCumulativeDetails] = useState({});
  // console.log("cumulativeDetails", cumulativeDetails);

  const handleGetData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/finance/check-tax-regime?p_EmployeeID=${selectedEmpValue || ''}&p_FYFromDate=${finacialYearsValues?.FYFromDate}&p_FYToDate=${finacialYearsValues?.FYToDate}&p_TaxRegime=${taxRegimeFetchValue || ''}`
      );
      if (response?.status === 200) {
        const cleanedData = response?.data;

        // console.log("GEtDAta", cleanedData);

        const taxRegimeVal = cleanedData?.regimedata[0]?.TaxRegime;
        setTaxRegimeFetchValue(taxRegimeVal);
        setCumulativeDetails({
          PreEmployerName:
            cleanedData?.cumulativeDetails[0]?.PreEmployerName || "",
          PreEmployerPaidAmount:
            cleanedData?.cumulativeDetails[0]?.PreEmployerPaidAmount || "",
          PreEmployerPaidIncomeTax:
            cleanedData?.cumulativeDetails[0]?.PreEmployerPaidIncomeTax || "",
        });

        setTableAccordianData(cleanedData?.data || []);
        setFormData(cleanedData?.data || []);
      }
    } catch (error) {
      console.error("Unexpected Error Occurred", error);
    }
  };

  // Pagination Handler
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(
    startIndex + itemsPerPage,
    tableAccordianData.length
  );
  const paginatedData = tableAccordianData.slice(startIndex, endIndex);

  const filteredData = paginatedData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const [formData, setFormData] = useState(filteredData);
  // console.log("formData", formData);

  const [changedData, setChangedData] = useState([]);
  // console.log("changedData", changedData);
  // window.globalVar = "I am a global variable";

  
  const handleChange = (
    ITSectionTypes,
    ITSectionGroups,
    ID,
    data,
    subIndex,
    field,
    value
  ) => {
    // Store the changed data temporarily
    const changedItem = { ...data, [field]: value || 0 };

    setFormData(prevData => {
      // First update just the changed item
      const updatedData = prevData.map(item =>
        item.ID === ID && item.ITSection === data.ITSection
          ? { ...item, [field]: value || 0 }
          : item
      );

      // Then calculate the new applicable values
      return calculateApplicableValues(updatedData, changedItem);
    });
  };

  // Separate function for calculating applicable values
  const calculateApplicableValues = (formData, changedItem) => {
    if (changedItem?.ITSectionGroupID != null) {
      // Get all items in the same group
      const groupItems = formData.filter(
        item => item.ITSectionGroupID === changedItem.ITSectionGroupID
      );

      // Calculate total group limit
      const groupLimit = groupItems.reduce(
        (sum, item) => sum + (parseFloat(item.ITSectionLimit) || 0),
        0
      );

      // Calculate total employee contributions
      const totalContributions = groupItems.reduce(
        (sum, item) => sum + (parseFloat(item.EmployeeContribution) || 0),
        0
      );

      // Calculate ratio if over limit
      const ratio = totalContributions > groupLimit
        ? groupLimit / totalContributions
        : 1;

      // Update all items in the group
      return formData.map(item => {
        if (item.ITSectionGroupID === changedItem.ITSectionGroupID) {
          return {
            ...item,
            ApplicableValue: ratio < 1
              ? Math.round(parseFloat(item.EmployeeContribution || 0) * ratio * 100) / 100
              : parseFloat(item.EmployeeContribution || 0)
          };
        }
        return item;
      });
    } else {
      // For non-group items
      return formData.map(item => {
        if (item.ID === changedItem.ID && item.ITSection === changedItem.ITSection) {
          return {
            ...item,
            ApplicableValue: Math.min(
              parseFloat(item.EmployeeContribution || 0),
              parseFloat(item.ITSectionLimit || Infinity)
            )
          };
        }
        return item;
      });
    }
  };

  // Remove the useEffect with prevFormDataRef - it's not needed anymore
  // console.log("formData", formData);
  const [activeClientKey, setActiveClientKey] = useState([]); // Stores open client accordions
  const [activeProjectKey, setActiveProjectKey] = useState({}); // Stores open project accordions under each client

  useEffect(() => {
    // Open all client accordions
    const allClientKeys = formData.map((_, index) => index.toString());

    // Open all ITSectionGroup accordions under each client
    const allProjectKeys = formData.reduce((acc, item, index) => {
      if (!acc[index]) acc[index] = [];

      // Extract unique ITSectionGroups per ITSectionType
      const projectGroups = [
        ...new Set(
          formData
            .filter((el) => el.ITSectionTypes === item.ITSectionTypes)
            .map((el, idx) => idx.toString()) // Ensure correct index-based keys
        ),
      ];

      acc[index] = projectGroups; // Open all ITSectionGroups
      return acc;
    }, {});

    setActiveClientKey(allClientKeys); // Open all clients
    setActiveProjectKey(allProjectKeys); // Open all ITSectionGroups under each client
  }, [formData]);


  const handleClientToggle = (clientKey) => {
    setActiveClientKey(
      (prev) =>
        prev.includes(clientKey)
          ? prev.filter((key) => key !== clientKey) // Close if already open
          : [...prev, clientKey] // Open if closed
    );
  };

  const handleProjectToggle = (ITIndex, itSectionGroupKey) => {
    setActiveProjectKey((prev) => ({
      ...prev,
      [ITIndex]: prev[ITIndex]?.includes(itSectionGroupKey)
        ? prev[ITIndex].filter((key) => key !== itSectionGroupKey) // Close if open
        : [...(prev[ITIndex] || []), itSectionGroupKey], // Open if closed
    }));
  };
  const getSectionName = (section) => {
    const parts = section.split("#");
    return parts.length > 1 ? parts[1] : section; // Return the portion after '#' or the full string if '#' is not found
  };

  const [finacialYearsValues, setFinancialYearsValues] = useState({
    value: "",
    label: "",
    FYToDate: "",
    FYFromDate: "",
  });
  const [selectedEmpValue, setSelectedEmployee] = useState();
  // console.log("finacialYearsValues", finacialYearsValues);

  const handleSelect = async (selectedOption, name) => {
    // console.log("selectedOption", selectedOption);

    if (name === "financialYear") {
      setFinancialYearsValues({
        value: selectedOption.value,
        label: selectedOption.label,
        FYToDate: selectedOption.FYToDate,
        FYFromDate: selectedOption.FYFromDate,
      });
    } else if (name === "employeeID") {
      setSelectedEmployee(selectedOption.value);
    } else if (name === "taxRegime") {
      setTaxRegimeFetchValue(selectedOption.value);
    }

    const value = selectedOption.value;
    // setFormData((prevData) => {
    //     const updatedData = { ...prevData, [name]: value };

    //     // Trigger validation for the specific field after updating
    //     // validateField(name, value);

    //     return updatedData;
    // });
  };

  const handleHeaderChange = (event) => {
    const { name, value } = event.target;
    setCumulativeDetails((prevState) => ({ ...prevState, [name]: value }));

    // Validate this field on change
    // validateField(name, value);
  };

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formSendData = {
      EmployeeID: selectedEmpValue,
      TaxRegime: taxRegimeFetchValue,
      PreEmployerName: cumulativeDetails?.PreEmployerName,
      PreEmployerPaidAmount: cumulativeDetails?.PreEmployerPaidAmount,
      PreEmployerPaidIncomeTax: cumulativeDetails?.PreEmployerPaidIncomeTax,
      records: formData?.map((ele, index) => ({
        EmployeeID: ele?.EmployeeID,
        FYFromDate: ele?.FYFromDate,
        FYToDate: ele?.FYToDate,
        TaxRegime: ele?.TaxRegime,
        FromDate: ele?.FromDate,
        ToDate: ele?.ToDate,
        ITSectionID: ele?.ITSectionID,
        IsITSectionFixed: ele?.IsITSectionFixed || 0,
        IsITDeclarationRequired: ele?.IsITDeclarationRequired || 0,
        ITSectionLimit: ele?.ITSectionLimit,
        EmployeeContribution: ele?.EmployeeContribution,
        ApplicableValue: ele?.ApplicableValue,
      })),
    };
    // console.log("formSendData", formSendData);

    try {
      const resoponse = await PostServiceCaller(
        `${API_URL}income/tax/declarations`,
        formSendData,
        "post"
      );

      if (resoponse?.status === 200) {
        toast.success("Data Submitted Successfully ");
        setTimeout(() => window.location.reload(), 2000);
      }
    } catch (error) {
      console.error("Data Posting Error:", error);
    }
  };

  return (
    <div className="Container">
      <form
        // onSubmit={handleSubmit}
        id="formOne"
        className="rounded bg-white mt-2"
      >
        <div className="row row-flex g-2">
          {/** Grid one */}
          <div className="col-md-6 flex-col mt-1">
            <div class="card">
              <div class="card-header">
                <h5 className="subheading">Filter Details</h5>
              </div>
              <div className="card-body">
                <div class="row">
                  <div className="col-md-6">
                    {/* <div class="form-group"> */}
                    <label className="form-label">Financial Year</label>

                    <Select
                      name="financialYear"
                      value={financialYearOptions?.find(
                        (o) => o.value === finacialYearsValues?.value
                      )}
                      onChange={(selectedOptions, action) =>
                        handleSelect(selectedOptions, action.name)
                      }
                      className={` `}
                      options={[
                        { value: null, label: "Select" },
                        ...financialYearOptions,
                      ]}
                    />
                  </div>
                  {/* </div> */}
                  <div className="col-md-6">
                    {/* <div class="form-group"> */}
                    <label className="form-label">Employee</label>
                    <Select
                      name="employeeID"
                      value={employeeOptions?.find(
                        (o) => o.value == selectedEmpValue
                      )}
                      onChange={(selectedOptions, action) =>
                        handleSelect(selectedOptions, action.name)
                      }
                      className={`  `}
                      options={[
                        { value: null, label: "Select" },
                        ...employeeOptions,
                      ]}
                    />
                  </div>
                  {/* </div> */}
                </div>
                <div className="row">
                  <div className="col-md-6">
                    {/* <div class="form-group"> */}
                    <label className="form-label">Tax Regime</label>
                    <Select
                      name="taxRegime"
                      onChange={(selectedOption, action) =>
                        handleSelect(selectedOption, action.name)
                      }
                      value={
                        regimeTypeOptions?.find(
                          (o) => o.value === Number(taxRegimeFetchValue)
                        ) || null
                      }
                      options={[
                        { value: null, label: "Select" },
                        ...regimeTypeOptions,
                      ]}
                    />

                    {/* </div> */}
                  </div>
                  <div className="d-flex flex-column justify-content-end align-items-end">
                    <div className="col-md-6">
                      <div className="text-end">
                        <button
                          className="custom-btn"
                          onClick={() => handleGetData()}
                          type="button"
                        >
                          Get data
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 flex-col mt-1">
            <div class="card">
              <div class="card-header">
                <h5 className="subheading">Previous Employment Details</h5>
              </div>
              <div className="card-body">
                <div class="row">
                  <div class="col-md-6">
                    {/* <div class="form-group"> */}
                    <label className="form-label">Pre-Employer Name </label>
                    <input
                      type="text"
                      name="PreEmployerName"
                      placeholder="PreEmployerName"
                      className={`form-control`}
                      value={cumulativeDetails?.PreEmployerName}
                      onChange={handleHeaderChange}
                    />

                    {/* </div> */}
                  </div>
                  <div class="col-md-6">
                    {/* <div class="form-group"> */}
                    <label className="form-label">
                      Pre-Employer Paid Amount{" "}
                    </label>
                    <input
                      type="text"
                      name="PreEmployerPaidAmount"
                      placeholder="PreEmployerPaidAmount"
                      className={`form-control`}
                      value={cumulativeDetails?.PreEmployerPaidAmount}
                      onChange={handleHeaderChange}
                    />

                    {/* </div> */}
                  </div>
                </div>
                <div className="row">
                  <div class="col-md-6">
                    {/* <div class="form-group"> */}
                    <label className="form-label">
                      Pre-Employement TDS Paid{" "}
                    </label>
                    <input
                      type="text"
                      name="PreEmployerPaidIncomeTax"
                      placeholder="PreEmployerPaidIncomeTax"
                      className={`form-control`}
                      value={cumulativeDetails?.PreEmployerPaidIncomeTax}
                      onChange={handleHeaderChange}
                    />

                    {/* </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row row-flex">
          {/** Grid one */}
          <div className="col-md-12 flex-col mt-1">
            <div class="card">
              <div class="card-header">
                <h5 className="subheading">Income Tax Declaration</h5>
              </div>
              <div className="card-body">
                {formData.length != 0 ? (
                  <Table bordered stripped rounded>
                    <thead id="thcolor">
                      <tr>
                        {/* <th></th>
                                            <th></th> */}
                        <th>Tax Section</th>
                        <th>Max Limit</th>
                        <th>Declaration Amount</th>
                        <th>Deductible Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(
                        formData.reduce((acc, item) => {
                          if (!acc[item.ITSectionTypes]) {
                            acc[item.ITSectionTypes] = {};
                          }
                          if (!acc[item.ITSectionTypes][item.ITSectionGroup]) {
                            acc[item.ITSectionTypes][item.ITSectionGroup] = [];
                          }
                          acc[item.ITSectionTypes][item.ITSectionGroup].push(
                            item
                          );
                          return acc;
                        }, {})
                      ).map(([ITSectionTypes, ITSectionGroups], ITIndex) => (
                        <tr key={ITIndex}>
                          <td colSpan={6} className="px-0">
                            <Accordion
                              activeKey={activeClientKey}
                              onSelect={(key) => handleClientToggle(key)}
                            >
                              <Accordion.Item eventKey={ITIndex.toString()}>
                                <Accordion.Header className="">
                                  <div className="flex-grow-1 text-dark fw-bold">
                                    {getSectionName(ITSectionTypes)}
                                  </div>
                                  <span className="me-2 accordion_icon">
                                    <FontAwesomeIcon
                                      icon={
                                        activeClientKey.includes(
                                          ITIndex.toString()
                                        )
                                          ? faMinus
                                          : faPlus
                                      }
                                    />
                                  </span>
                                </Accordion.Header>
                                <Accordion.Body
                                  style={{ padding: "10px 0px !important" }}
                                  className="px-0"
                                >
                                  <Accordion
                                    activeKey={activeProjectKey[ITIndex] || []}
                                    onSelect={(key) => handleProjectToggle(ITIndex, key)}
                                  >
                                    {Object.entries(ITSectionGroups).map(
                                      (
                                        [iTSectionGroup, items],
                                        itSectionIndex
                                      ) => (
                                        <Accordion.Item
                                          eventKey={itSectionIndex.toString()} key={itSectionIndex}
                                        >
                                          <Accordion.Header>
                                            <div className="flex-grow-1  ms-2 text-dark ">
                                              {getSectionName(iTSectionGroup)}
                                            </div>
                                            <span className="me-2 accordion_icon">
                                              <FontAwesomeIcon
                                                icon={
                                                  activeProjectKey[ITIndex]?.includes(itSectionIndex.toString())
                                                    ? faMinus
                                                    : faPlus
                                                }
                                              />
                                            </span>
                                          </Accordion.Header>
                                          <Accordion.Body className="px-0">
                                            <Table bordered striped hover>
                                              <tbody>
                                                {items.map((data, subIndex) => (
                                                  <tr
                                                    key={subIndex}
                                                    className="border"
                                                  >
                                                    <td
                                                      style={{ width: "222px" }}
                                                    >
                                                      <p className="ms-5">
                                                        {data.ITSection}
                                                      </p>
                                                    </td>
                                                    <td
                                                      style={{ width: "209px" }}
                                                    >
                                                      <input
                                                        readOnly
                                                        value={
                                                          data.ITSectionLimit
                                                        }
                                                        className="form-control text-end"
                                                        type="number"
                                                      />
                                                    </td>
                                                    <td>
                                                      <input
                                                        value={
                                                          data.EmployeeContribution
                                                        }
                                                        type="number"
                                                        onChange={(e) =>
                                                          handleChange(
                                                            ITSectionTypes,
                                                            ITSectionGroups,
                                                            data.ID,
                                                            data,
                                                            subIndex,
                                                            "EmployeeContribution",
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control text-end"
                                                      />
                                                    </td>
                                                    <td>
                                                      <input
                                                        readOnly
                                                        value={
                                                          data.ApplicableValue
                                                        }
                                                        type="number"
                                                        onChange={(e) =>
                                                          handleChange(
                                                            ITSectionTypes,
                                                            ITSectionGroups,
                                                            data.ID,
                                                            data,
                                                            subIndex,
                                                            "ApplicableValue",
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control text-end"
                                                      />
                                                    </td>
                                                  </tr>
                                                ))}
                                              </tbody>
                                            </Table>
                                          </Accordion.Body>
                                        </Accordion.Item>
                                      )
                                    )}
                                  </Accordion>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="d-flex justify-content-end mt-2">
            <div className="d-flex">
              <div>
                <button
                  type="button"
                  className="cancel-btn me-2"
                  onClick={() => window.location.reload()}
                >
                  Cancel
                </button>
              </div>
              <div>
                <button
                  disabled={loading ? true : false}
                  onClick={(e) => handleSubmit(e)}
                  type="submit"
                  className=" custom-btn"
                >
                  {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default EmployeeITDeclarations;
